import ProfileNavigate from "./ProfileNavigate";
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';

const ProfileNavigateLayout = ({ children }) => {
	return (
		<>
			<Header />
			<div className="container-fluid" style={{marginTop:"70px", marginBottom:0, height:"80%"}}>
				<div className="row">
					<div className="col-md-5 col-lg-4 col-xl-3">
						<ProfileNavigate />
					</div>
					<div className="col-md-7 col-lg-8 col-xl-9">
						{children}
					</div>
				</div>
			</div>
		</>
	)
}

export default ProfileNavigateLayout;